import {
	ExerciseTagDTO,
	GameRewardDetailDTO,
	InformationCategoryDTO,
	Paginated,
	RewardListFilter,
	SetSubTitleDTO,
	SuccessResponse,
	rolesListRes,
} from './DTO/common.interface';
import { TaskScheduledRewardDTO } from './DTO/task/regular.interface';
import { apiSlice } from './apiSlice';

export const commonApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRoles: builder.query<SuccessResponse<rolesListRes[]>, null>({
			query: () => ({
				url: `/web/roles/staff`,
			}),
		}),

		uploadMedia: builder.mutation<
			SuccessResponse<{ fileKey: string; url: string; name: string }[]>,
			FormData
		>({
			query: (body) => ({ url: `/web/media/upload`, method: 'POST', body }),
		}),

		getCountries: builder.query<SuccessResponse<null>, any>({
			query: () => ({ url: `/web/info/countries` }),
		}),
		getInformationType: builder.query<
			SuccessResponse<InformationCategoryDTO>,
			number
		>({
			query: (type) => ({ url: `/web/information/category/${type}` }),
			providesTags: ['InformationType'],
		}),
		setSubTitle: builder.mutation<SuccessResponse<any>, SetSubTitleDTO>({
			query: (body) => ({
				url: `/web/information/category`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['InformationType'],
		}),
		getTagList: builder.query<SuccessResponse<ExerciseTagDTO[]>, null>({
			query: () => ({
				url: `/web/exercise/tag`,
				method: 'GET',
			}),
		}),
		getRewardList: builder.query<
			SuccessResponse<Paginated<GameRewardDetailDTO>>,
			RewardListFilter
		>({
			query: (body) => ({
				url: `/web/game/color-gallery/series/reward-page`,
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const {
	useGetRolesQuery,
	useGetCountriesQuery,
	useGetInformationTypeQuery,
	useUploadMediaMutation,
	useSetSubTitleMutation,
	useGetTagListQuery,
	useGetRewardListQuery,
} = commonApiSlice;
